export const getShipmentDefaultFilters = () => ({
  CreatedDateFrom: undefined,
  CreatedDateTo: undefined,
  ShipmentStatus: undefined,
  trailerNumber: undefined,
  ShipmentNo: undefined,
  pageNumber: 1,
  pageSize: 10,
});

export const SaversShipmentColumns = {
  progressing: false,
  success: true,
  error: false,
  data: [
    {
      columnName: 'Trailer Number',
      columnValue: 'trailerNumber',
      id: '2fa37273-7ec0-46df-b951-1ad6f5b6f775',
    },
    {
      columnName: 'Shipment Status',
      columnValue: 'status',
      id: '0454406a-6cb6-4148-90f0-6e6197ab7995',
    },
    {
      columnName: 'ETD',
      columnValue: 'etd',
      id: '0454406a-6cb6-4148-90f0-6e6197ab7995',
    },
    {
      columnName: 'ETA',
      columnValue: 'eta',
      id: '0454406a-6cb6-4148-90f0-6e6197ab7995',
    },
  ],
  message: false,
};
